import React from "react";
import NewEvent from "../../Components/NewEvent/NewEvent";

export default function AddNewEvent () {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Add New Event</h2>
        <NewEvent />
      </div>
    </div>
  );
};